import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const NAV = [
  { label: "Leistungen", href: "#leistungen" },
  { label: "Preise", href: "#preise" },
  { label: "Ablauf", href: "#ablauf" },
  { label: "Änderungen", href: "#aenderungen" },
  { label: "FAQ", href: "#faq" },
];

const scrollTo = scrollToId;

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    setTimeout(() => scrollTo(href), 10);
  };

  return (
    <>
      <motion.header
        initial={{ y: -80 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
          scrolled ? "bg-black/70 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
        }`}
        data-testid="site-header"
      >
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10 flex items-center justify-between h-20">
          <button
            onClick={() => go("#top")}
            className="font-display text-xl sm:text-2xl tracking-tight text-white flex items-center gap-2"
            data-testid="brand-logo"
          >
            <span className="inline-block h-2.5 w-2.5 bg-[#FF3B00]" />
            Landingsstrategie<span className="text-[#FF3B00]">.</span>
          </button>

          <nav className="hidden md:flex items-center gap-9">
            {NAV.map((n) => (
              <button
                key={n.href}
                onClick={() => go(n.href)}
                className="font-tech text-xs uppercase tracking-[0.15em] text-neutral-400 hover:text-white transition-colors link-underline"
                data-testid={`nav-${n.href.replace("#", "")}`}
              >
                {n.label}
              </button>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <button
              onClick={() => go("#kontakt")}
              className="hidden sm:inline-flex items-center bg-[#FF3B00] text-white font-tech text-xs uppercase tracking-[0.15em] px-5 py-3 hover:bg-[#FF5C2B] active:scale-95 transition-all duration-200"
              data-testid="header-cta"
            >
              Website anfragen
            </button>
            <button
              className="md:hidden text-white p-2"
              onClick={() => setOpen(true)}
              data-testid="menu-open"
              aria-label="Menü öffnen"
            >
              <Menu size={26} />
            </button>
          </div>
        </div>
      </motion.header>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[70] bg-[#050505] md:hidden flex flex-col"
            data-testid="mobile-menu"
          >
            <div className="flex items-center justify-between h-20 px-6">
              <span className="font-display text-xl text-white">Landingsstrategie<span className="text-[#FF3B00]">.</span></span>
              <button onClick={() => setOpen(false)} className="text-white p-2" data-testid="menu-close" aria-label="Menü schließen">
                <X size={28} />
              </button>
            </div>
            <div className="flex flex-col gap-2 px-6 mt-6">
              {NAV.concat({ label: "Kontakt", href: "#kontakt" }).map((n, i) => (
                <motion.button
                  key={n.href}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.05 * i }}
                  onClick={() => go(n.href)}
                  className="text-left font-display text-4xl text-white py-3 border-b border-white/10"
                >
                  {n.label}
                </motion.button>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
